module.exports = __webpack_public_path__ + "static/media/smallCloseIcon.8adc2e25.svg";